
import React, { useEffect, useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Bar, BarChart, Line, LineChart, ResponsiveContainer, XAxis, YAxis, Tooltip } from "recharts";
import { useInView } from 'react-intersection-observer';

// Chart data
const debtData = [
  { name: "Jan", value: 40 },
  { name: "Feb", value: 30 },
  { name: "Mar", value: 45 },
  { name: "Apr", value: 50 },
  { name: "May", value: 60 },
  { name: "Jun", value: 65 },
  { name: "Jul", value: 70 },
  { name: "Aug", value: 75 },
  { name: "Sep", value: 80 },
  { name: "Oct", value: 85 },
  { name: "Nov", value: 90 },
  { name: "Dec", value: 95 },
];

const complianceData = [
  { name: "Jan", value: 85 },
  { name: "Feb", value: 90 },
  { name: "Mar", value: 88 },
  { name: "Apr", value: 92 },
  { name: "May", value: 95 },
  { name: "Jun", value: 89 },
  { name: "Jul", value: 92 },
  { name: "Aug", value: 94 },
  { name: "Sep", value: 97 },
  { name: "Oct", value: 96 },
  { name: "Nov", value: 98 },
  { name: "Dec", value: 99 },
];

const DashboardCharts: React.FC = () => {
  const { ref: debtChartRef, inView: debtChartInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const { ref: complianceChartRef, inView: complianceChartInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  return (
    <div className="grid gap-6 md:grid-cols-2">
      <Card ref={debtChartRef}>
        <CardHeader>
          <CardTitle>Debt Trend</CardTitle>
          <CardDescription>
            Monthly debt position for the current year
          </CardDescription>
        </CardHeader>
        <CardContent>
          {debtChartInView ? (
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={debtData}>
                <XAxis dataKey="name" fontSize={12} tickLine={false} axisLine={false} />
                <YAxis fontSize={12} tickLine={false} axisLine={false} tickFormatter={(value) => `₹${value}M`} />
                <Tooltip formatter={(value) => [`₹${value}M`, "Debt"]} />
                <Bar dataKey="value" fill="hsl(var(--primary))" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <div className="w-full h-[300px] bg-muted/20 animate-pulse flex items-center justify-center text-muted">
              Loading chart...
            </div>
          )}
        </CardContent>
      </Card>
      <Card ref={complianceChartRef}>
        <CardHeader>
          <CardTitle>Compliance Score Trend</CardTitle>
          <CardDescription>
            Monthly compliance score for the current year
          </CardDescription>
        </CardHeader>
        <CardContent>
          {complianceChartInView ? (
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={complianceData}>
                <XAxis dataKey="name" fontSize={12} tickLine={false} axisLine={false} />
                <YAxis fontSize={12} tickLine={false} axisLine={false} domain={[80, 100]} tickFormatter={(value) => `${value}%`} />
                <Tooltip formatter={(value) => [`${value}%`, "Score"]} />
                <Line type="monotone" dataKey="value" stroke="hsl(var(--accent))" strokeWidth={2} />
              </LineChart>
            </ResponsiveContainer>
          ) : (
            <div className="w-full h-[300px] bg-muted/20 animate-pulse flex items-center justify-center text-muted">
              Loading chart...
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default DashboardCharts;
